import React, { useEffect, useRef, useState } from 'react'
import { Checkbox, ProgressLoader } from '../Elements';
import ConfirmationModal from '../ConfirmationModal';
import MaterailTable from '../Elements/MaterialTable';
import { PaymentSetProps } from '../../pages/InsertUpdatePaymentSet';

type SetVpTableProps = {
    activePostList: any[];
    tableSelectedRows: any;
    formValues: PaymentSetProps
}

const SetVpTable: React.FC<SetVpTableProps> = ({ activePostList, tableSelectedRows, formValues }) => {

    const [operationsLoading, setOperationsLoading] = useState<boolean>(false);

    const LinearColor = () => {
        if (operationsLoading) {
            return <ProgressLoader />;
        }
        return null;
    };

    const headCells = [
        {
            id: 'vpid',
            numeric: true,
            label: 'ID',
            isprimary: true,
            className: "min-w-[80px]",
            colWidth: 10,
            hide: true,
            exceptToExcel: true
        },
        {
            id: 'vpdisplayname',
            numeric: true,
            label: 'POS Adı',
            className: "min-w-[360px]",
            maxLength: 42,
            colWidth: 20, // For excel
        },
        {
            id: 'bankname',
            numeric: true,
            label: 'Banka Adı',
            className: "min-w-[250px]",
            maxLength: 30,
            colWidth: 20, // For excel
        },
    ]

    return (
        <>
            {LinearColor()}
            <MaterailTable
                ref={tableSelectedRows}
                headerCells={headCells}
                tableData={activePostList || []}
                isRowSelect={true}
                isLoading={false}
                defaultSelected={formValues.vpList}
            />
        </>
    )
}

export default SetVpTable;